<script>
import Cleave from "vue-cleave-component";
import { debounce } from "lodash";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { scroller } from "vue-scrollto/src/scrollTo";
import { ref } from 'vue';
import clientConfig from '/src/config/client';

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBBtnGroup,
  MDBTooltip
} from "mdb-vue-ui-kit";

import LifetimeSliderInput from '@lifetime-gallagher/lifetime-slider-input'

// import {
//   ValidationProvider,
//   ValidationObserver,
//   configure,
//   extend
// } from "vee-validate";

// import { required } from "vee-validate/dist/rules";

// configure({
//   classes: {
//     invalid: "is-invalid"
//   }
// });

// extend("required", {
//   ...required,
//   message: "This field is required"
// });

// export function debounce(fn, delay) {
//   var timeoutID = null;
//   return function () {
//     clearTimeout(timeoutID);
//     var args = arguments;
//     var that = this;
//     timeoutID = setTimeout(function () {
//       fn.apply(that, args)
//     }, delay);
//   }
// }

export default {
  name: 'QuotePanel',
  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBBtnGroup,
    MDBTooltip,

    LifetimeSliderInput,
    Cleave

    //ValidationProvider,
    //ValidationObserver
  },

  setup() {
    const tooltip1 = ref(false);
    const tooltip2 = ref(false);
    const tooltip3 = ref(false);
    return {
      tooltip1,
      tooltip2,
      tooltip3
    }
  },

  computed: {
    ...mapFields([
      "age",
      "annualIncome",
      "gender",
      "coverAmount",
      "benefitPeriod",
      "waitingPeriod",
      "protectionBenefits",
      "superBenefits",
      "unitsOfCover",
      "costPerPeriod",
      "costPerYear",
      "premiumVariables",
    ]),
    ...mapGetters([
      "debugMode",
      "updateTriggered",
      "data",
    ])
  },

  methods: {
    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ipApp");
      this.triggerHeightCheck();
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    printCalculation() {
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'printResults',
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: printResults");
      window.print();
    },

    toggleGender(vType) {
      this.gender_male = vType === "male";
      this.$store.commit("updateGender", vType);
    },
    toggleGenderBtn(e) {
      this.toggleGender(e.target.value);
    },

    toggleCover(vType) {
      this.cover_75 = parseFloat(vType) === 0.75;
      this.$store.commit("updateCoverAmount", vType);
    },
    toggleCoverBtn(e) {
      this.toggleCover(e.target.value);
    },

    toggleBenefit(vType) {
      this.benefit_2 = parseInt(vType) === 2;
      this.$store.commit("updateBenefitPeriod", parseInt(vType));
    },
    toggleBenefitBtn(e) {
      this.toggleBenefit(e.target.value);
    },

    toggleWaiting(vType) {
      this.waiting_LowerLimit = parseInt(vType) === this.clientConfig.content.calculation.waitingPeriodLowerLimit;
      this.$store.commit("updateWaitingPeriod", vType);
    },
    toggleWaitingBtn(e) {
      this.toggleWaiting(e.target.value);
    },

    vlookup(lookupData) {

      // NEW - CALLING API
      if (this.data.params.calculationMethod === 'visionsuper') {
        if (this.premiumVariables) {
          // Loop through data in ascending order, until we find the closest value
          var dataArr;
          if (lookupData.benefitPeriod == 2) {          
            dataArr = this.premiumVariables['incomeProtection' + lookupData.benefitPeriod][lookupData.gender][lookupData.waitingPeriod]
            // console.warn('waiting period 2', dataArr)
          }
          else {
            dataArr = this.premiumVariables['incomeProtection' + lookupData.benefitPeriod][lookupData.gender][lookupData.waitingPeriod]
            // console.warn('waiting period 65', dataArr)
          }
          for (var i = 0; i < dataArr.length; i++) {
            if (dataArr[i].age > lookupData.age) {
              // Now we've gone past it - get the previous row's rate
              // console.warn('Lookup: age: ', lookupData.age, 'rate: ', dataArr[i - 1].rate);
              return dataArr[i - 1].rate;
            }
          }
          // Show the last value we have, make sure other checks are in place to ensure it is valid
          return dataArr[dataArr.length - 1].rate;
        }

      // OLD - REFERRING TO LOCAL DATA
      } else if (this.data.params.calculationMethod === 'supersa') {
        // console.log('vlookup', lookupData, this.data.quoteData);
        if (this.data.quoteData === undefined || this.data.quoteData === null) {
          return false;
        } else {
          // Loop through data in ascending order, until we find the closest value
          // var dataArr;
          if(lookupData.benefitPeriod === 2) {
            dataArr = this.data.quoteData['incomeProtection' + lookupData.benefitPeriod][lookupData.waitingPeriod]
          }
          else {
            dataArr = this.data.quoteData['incomeProtection' + lookupData.benefitPeriod][lookupData.gender][lookupData.waitingPeriod]
          }
          for (i = 0; i < dataArr.length; i++) {
          // for (var i = 0; i < dataArr.length; i++) {
            if (dataArr[i].age > lookupData.age) {
              // Now we've gone past it - get the previous row's rate
              // console.log('age: ', lookupData.age, 'rate: ', dataArr[i - 1].rate);
              return dataArr[i - 1].rate;
            }
          }
          // Show the last value we have, make sure other checks are in place to ensure it is valid
          return dataArr[dataArr.length - 1].rate;
        }
      }
      return false;
    },

    setDefaults() {
      this.typedAge = parseInt(this.age);
      this.typedAnnualIncome = parseInt(this.annualIncome);

      if (this.gender === null || this.gender.length < 1) {
        this.toggleGender("male");
      } else {
        this.toggleGender(this.gender);
      }

      if (this.coverAmount === null || this.coverAmount.length < 1) {
        this.toggleCover("0.75");
      } else {
        this.toggleCover(this.coverAmount);
      }

      if (this.benefitPeriod === null || this.benefitPeriod.length < 1) {
        this.toggleBenefit(2);
      } else {
        this.toggleBenefit(this.benefitPeriod);
      }

      if (this.waitingPeriod === null || this.waitingPeriod.length < 1) {
        this.toggleWaiting(this.clientConfig.content.calculation.waitingPeriodLowerLimit);
      } else {
        this.toggleWaiting(this.waitingPeriod);
      }
    },

    calculateQuote() {
      this.showCalculation = true;
      const scrollTo = scroller();
      scrollTo("#ipApp");
      this.runCalculation();
    },

    runCalculation() {
      let totalBenefit = 0;
      let projectionBenefit = 0;
      let superBenefit = 0;
      let units = 0;
      let lookupData = {};
      let costPerPeriod = 0;
      let costPerYear = 0;
      let vLookupRate = 0;

      if (this.data.params.calculationMethod === 'visionsuper') { ///////////////////////////////////////////////////
        if (this.debugMode) {
          console.log(
            "this.annualIncome => ", this.annualIncome,
            " | ",
            "this.coverAmount => ", this.coverAmount,
            " | ",
            "this.data.params.salaryBenefitRate => ", this.data.params.salaryBenefitRate,
            " | ",
            "this.data.params.superBenefitRate => ", this.data.params.superBenefitRate,
            " | ",
            "this.data.params.singleUnit => ", this.data.params.singleUnit,
            " | ",
            "this.benefitPeriod => ", this.benefitPeriod,
            " | ",
            "this.waitingPeriod => ", this.waitingPeriod,
            " | ",
            "this.gender => ", this.gender,
            " | ",
            "this.age => ", this.age
          );
        }

        totalBenefit = this.annualIncome * this.coverAmount;
        if (this.debugMode)
          console.log(
            totalBenefit,
            " => totalBenefit = ",
            this.annualIncome,
            " * ",
            this.coverAmount
          );
        
        projectionBenefit = (this.annualIncome * this.data.params.salaryBenefitRate) / 12;
        if (this.debugMode)
          console.log(
            projectionBenefit,
            " => projectionBenefit = (",
            this.annualIncome,
            " * ",
            this.data.params.salaryBenefitRate,
            ") / 12"
          );
        
        superBenefit = (this.annualIncome * this.data.params.superBenefitRate) / 12
        if (this.debugMode)
          console.log(
            superBenefit,
            " => superBenefit = (",
            this.annualIncome,
            " * ",
            this.data.params.superBenefitRate,
            ") / 12"
          );
        
        units = Math.ceil( (totalBenefit / 12 ) / this.data.params.singleUnit)
        if (this.debugMode && !this.clientConfig.content.calculation.hideUnitResults)
          console.log(
            units,
            " => units = Math.ceil(", 
            totalBenefit, 
            " / 12) / ", 
            this.data.params.singleUnit, 
            ") (rounds a number up to the next largest integer)"
          );

        lookupData = {
          benefitPeriod: this.benefitPeriod,
          waitingPeriod: 'waitingPeriod' + this.waitingPeriod,
          gender: this.gender,
          age: this.age
        }

        vLookupRate = this.vlookup(lookupData);
        if (this.debugMode)
          console.log("vLookupRate => ", vLookupRate);

        costPerPeriod = vLookupRate * units;
        if (this.debugMode)
          console.log("costPerPeriod => ", costPerPeriod);

        costPerYear = costPerPeriod * 52.14;
        if (this.debugMode)
          console.log("costPerYear => ", costPerYear);
      
        this.$store.commit("updateProtectionBenefits", projectionBenefit);
        this.$store.commit("updateSuperBenefits", superBenefit);
        this.$store.commit("updateUnitsOfCover", units);
        this.$store.commit("updateCostPerPeriod", costPerPeriod);
        this.$store.commit("updateCostPerYear", costPerYear);

        if (this.showCalculation) {
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'userAge' + this.age,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: userAge" + this.age);
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'userGender' + (this.gender === "male" ? 'Male' : 'Female'),
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: userGender" + (this.gender === "male" ? 'Male' : 'Female'));
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'userSalary' + this.annualIncome,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: userSalary" + this.annualIncome);
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'coverAmount' + (this.coverAmount * 100) + '%',
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: coverAmount" + (this.coverAmount * 100) + '%');
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'benefitPeriod' + this.benefitPeriod,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: benefitPeriod" + this.benefitPeriod);
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'waitingPeriod' + this.waitingPeriod,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: waitingPeriod" + this.waitingPeriod);
          //------------------------
        }

      } else if (this.data.params.calculationMethod === 'supersa') { ///////////////////////////////////////////////////
        const fortnightlyDecimal = (12 / 313);
        
        if (this.debugMode) {
          console.log(
            "this.annualIncome => ", this.annualIncome,
            " | ",
            "this.coverAmount => ", this.coverAmount,
            " | ",
            "this.data.params.salaryBenefitRate => ", this.data.params.salaryBenefitRate,
            " | ",
            "this.data.params.superBenefitRate => ", this.data.params.superBenefitRate,
            " | ",
            "this.data.params.ipBenefitRate => ", this.data.params.ipBenefitRate,
            " | ",
            "this.benefitPeriod => ", this.benefitPeriod,
            " | ",
            "this.waitingPeriod => ", this.waitingPeriod,
            " | ",
            "this.age => ", this.age,
            " | ",
            "fortnightlyDecimal => ", fortnightlyDecimal
          );
        }

        let ipPayment = this.annualIncome * this.data.params.salaryBenefitRate * fortnightlyDecimal;
        if (this.debugMode)
          console.log(
            ipPayment,
            " => ipPayment = ",
            this.annualIncome,
            " * ",
            this.data.params.salaryBenefitRate,
            " * ",
            fortnightlyDecimal
          );
        
        ipPayment = Math.round(ipPayment * 100) / 100;
        if (this.debugMode)
          console.log(
            "ipPayment = ",
            ipPayment
          );

        let crbPayment = ipPayment * this.data.params.ipBenefitRate;
        if (this.debugMode)
          console.log(
            crbPayment,
            " => crbPayment = ",
            ipPayment,
            " * ",
            this.data.params.ipBenefitRate
          );

        crbPayment = Math.round(crbPayment * 100) / 100;
        if (this.debugMode)
          console.log(
            "crbPayment = ",
            crbPayment
          );

        lookupData = {
          benefitPeriod: this.benefitPeriod,
          waitingPeriod: 'waitingPeriod' + this.waitingPeriod,
          age: this.age
        }

        vLookupRate = this.vlookup(lookupData);
        if (this.debugMode)
          console.log("vLookupRate => ", vLookupRate);

        costPerPeriod = ((this.annualIncome * fortnightlyDecimal) * vLookupRate) / 100;
        if (this.debugMode)
          console.log("costPerPeriod => ", costPerPeriod, " = (", this.annualIncome, " * ", fortnightlyDecimal, ") * ", vLookupRate);

        costPerYear = costPerPeriod / fortnightlyDecimal;
        if (this.debugMode)
          console.log("costPerYear => ", costPerYear, " = ", costPerPeriod, " / ", fortnightlyDecimal);
      
        this.$store.commit("updateProtectionBenefits", ipPayment);
        this.$store.commit("updateSuperBenefits", crbPayment);
        this.$store.commit("updateCostPerPeriod", costPerPeriod);
        this.$store.commit("updateCostPerYear", costPerYear);

        if (this.showCalculation) {
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'userAge' + this.age,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: userAge" + this.age);
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'userSalary' + this.annualIncome,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: userSalary" + this.annualIncome);
          //------------------------
          this.$gtag.event('data', {
            'event_category': 'userInput',
            'event_label': 'waitingPeriod' + this.waitingPeriod,
            'value': 1
          });
          if (this.debugMode)
            console.log("GTAG Event: waitingPeriod" + this.waitingPeriod);
          //------------------------
        }
        
      } else { /////////////////////////////////////////////////////////////////////////////////////////////////////////
        console.log("Error: Invalid calculation configuration.")
      }
      this.triggerHeightCheck();
    },

    formatCurrency: (value, noCents = false) => {
      return value === null
        ? ""
        : noCents
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
  },

  mounted() {
    this.setDefaults();
    this.triggerHeightCheck();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },

  unmounted() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },

  watch: {
    updateTriggered: {
      handler: debounce(function() {
        this.triggerUpdate = Date.now();
      }, 300),
      deep: true
    },

    triggerUpdate() {
      this.runCalculation();
    },

    typedAnnualIncome: debounce(function (newVal) {
      this.typedAnnualIncome_ = newVal;
    }, 1300),

    typedAnnualIncome_(newIncome) {
      if (typeof newIncome === "string") {
        newIncome = parseInt(newIncome);
      }
      if (newIncome !== this.annualIncome) {
        if (newIncome < this.data.params.minSalary) {
          newIncome = this.data.params.minSalary;
        } else if (newIncome > this.data.params.maxSalary) {
          newIncome = this.data.params.maxSalary;
        }
        this.typedAnnualIncome = newIncome;
        this.$store.commit("updateAnnualIncome", newIncome);
      }
    },

    annualIncome(newIncome) {
      if (typeof newIncome === "string") {
        newIncome = parseInt(newIncome);
      }
      if (newIncome !== this.typedAnnualIncome) {
        if (newIncome < this.data.params.minSalary) {
          newIncome = this.data.params.minSalary;
        }
        this.typedAnnualIncome = newIncome;
      }
    },

    typedAge: debounce(function (newVal) {
      this.typedAge_ = newVal;
    }, 1300),

    typedAge_(newAge) {
      if (typeof newAge === "string") {
        newAge = parseInt(newAge);
      }
      if (newAge !== this.age) {
        if (newAge < this.data.params.minAge) {
          newAge = this.data.params.minAge;
        } else if (newAge > this.data.params.maxAge) {
          newAge = this.data.params.maxAge;
        }
        this.typedAge = newAge;
        this.$store.commit("updateAge", newAge);
      }
    },

    age(newAge) {
      if (typeof newAge === "string") {
        newAge = parseInt(newAge);
      }
      if (newAge !== this.typedAge) {
        if (newAge < this.data.params.minAge) {
          newAge = this.data.params.minAge;
        } else if (newAge > this.data.params.maxAge) {
          newAge = this.data.params.maxAge;
        }
        this.typedAge = newAge;
      }
    }
  },

  data() {
    return {
      clientConfig,
      showCalculation: false,
      typedAge: null,
      typedAge_: null,
      typedAnnualIncome: null,
      typedAnnualIncome_: null,
      triggerUpdate: null,
      formatOptions: {
        salary: {
          numeral: true,
          prefix: "$",
          //prefix: " p/a",
          //tailPrefix: true,
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 9,
          numeralDecimalScale: 2
        },
        number: {
          numericOnly: true,
          blocks: [2]
        }
      },
      gender_male: false,
      cover_75: false,
      benefit_2: false,
      waiting_LowerLimit: false
    }
  }
}
</script>

<template>
  <MDBContainer fluid>
    <MDBRow 
      class="p-0" 
      v-if="!showCalculation"
    >
      <MDBCol col="12" class="p-3 ps-4 pe-5 text-left bg-darker icon-briefcase-lg">
        <h4 class="pe-5" v-html="clientConfig.content.calculation.header"></h4>
      </MDBCol>
    </MDBRow>

    <MDBRow 
      class="p-0 quote-section" 
      v-else
    >
      <MDBCol 
        col="12" 
        :lg="!clientConfig.content.calculation.hideUnitResults ? '5' : '6'" 
        class="p-3 bg-darker d-flex justify-content-center"
      >
        <div class="align-self-center text-center">
          {{ clientConfig.content.calculation.resultHeader }}
          <br />
          <span class="big-result">
            ${{formatCurrency(protectionBenefits)}}
          </span>
          {{ clientConfig.content.calculation.benefitPeriod }}
          <br/>
          <small v-if="!cover_75 || clientConfig.content.calculation.showSuperBenefit">
            + ${{formatCurrency(superBenefits)}} into super
          </small>
        </div>
      </MDBCol>

      <MDBCol 
        col="6" 
        lg="3" 
        class="p-3 bg-mid-cyan d-flex justify-content-center"
        v-if="!clientConfig.content.calculation.hideUnitResults"
      >
        <div class="align-self-center text-center">
          <span class="big-result">
            {{unitsOfCover}}
          </span>
          <br />
          <strong>
            Units
          </strong>
          <br />
          {{ clientConfig.content.calculation.unitExplanation }}
        </div>
      </MDBCol>

      <MDBCol 
        :col="!clientConfig.content.calculation.hideUnitResults ? '6' : '12'" 
        :lg="!clientConfig.content.calculation.hideUnitResults ? '4' : '6'" 
        class="p-3 bg-light-cyan d-flex justify-content-center"
      >
        <div class="align-self-center text-center">
          <strong>
            Cost
          </strong>
          <br />
          <span class="big-result">
            ${{formatCurrency(costPerPeriod)}}
          </span>
          <br />
          {{ clientConfig.content.calculation.costPeriod }}
          <br />
          (${{formatCurrency(costPerYear)}} per year)
        </div>
      </MDBCol>
    </MDBRow>



    <!-- <ValidationObserver ref="observer" class="w-100"> -->
    <MDBRow class="p-0 pb-4 bg-light-grey">

      <MDBCol col="12" lg="6" class="pt-4 text-left">
        <MDBRow class="p-0">
          <MDBCol col="2" class="text-left pt-0">
            <div class="main-icon">
              <div class="icon-person"></div>
            </div>
          </MDBCol>

          <MDBCol col="10" class="text-left pt-2">
            <div class="form-group">
              <div class="input-holder">
                <label for="ageSlider" tabindex="0" id="ageSlider_label">
                  {{ clientConfig.content.calculation.ageLabel }}
                </label>
                <cleave
                  v-model="typedAge"
                  :options="formatOptions.number"
                  name="typedAge"
                  type="text"
                  id="typedAge"
                  class="form-control mini-input"
                  tabindex="0"
                  aria-labelledby="ageSlider_label"
                ></cleave>
              </div>
              <LifetimeSliderInput
                v-model="age"
                :min="data.params.minAge"
                :max="data.params.maxAge"
                :tooltips="false"
              />
              <!-- data.params.minAge / data.params.maxAge ??? -->
            </div>

            <div 
              class="form-group" 
              v-if="!clientConfig.content.calculation.hideGender"
            >
              <label for="gender" tabindex="0" id="gender_label">
                {{ clientConfig.content.calculation.genderLabel }}
              </label>
              <!-- <ValidationProvider name="genderValidation"> -->
                <input
                  type="hidden"
                  name="gender"
                  id="gender"
                  :value="gender"
                />
              <!-- </ValidationProvider> -->
              
              <br />

              <MDBBtnGroup 
                class="multi-select-group shadow-0" 
                role="radiogroup" 
                aria-labelledby="gender_label"
              >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="male"
                  @click="toggleGenderBtn"
                  :class="gender_male ? 'active' : ''"
                  role="radio"
                  tabindex="0" 
                  aria-label="Male"
                  >MALE</MDBBtn
                >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="female"
                  @click="toggleGenderBtn"
                  :class="!gender_male ? 'active' : ''"
                  role="radio"
                  tabindex="0" 
                  aria-label="Female"
                  >FEMALE</MDBBtn
                >
              </MDBBtnGroup>
            </div>
          </MDBCol>
        </MDBRow>

        <MDBRow class="p-0 pt-4">
          <MDBCol col="2" class="text-left pt-0">
            <div class="main-icon">
              <div class="icon-dollars"></div>
            </div>
          </MDBCol>

          <MDBCol col="10" class="text-left pt-2">
            <div class="form-group">
              <div class="input-holder">
                <label for="incomeSlider" tabindex="0" id="incomeSlider_label">
                  {{ clientConfig.content.calculation.annualIncomeLabel }}
                  <MDBTooltip 
                    v-model="tooltip1"
                    boundary="#ipApp"
                    direction="top"
                  >
                    <template #reference>
                      <span class="icon-info altPos"></span>
                    </template>
                    <template #tip>
                      <span>
                        {{ clientConfig.content.calculation.annualIncomeTooltip }}
                      </span>
                    </template>
                  </MDBTooltip>
                </label>
                <cleave
                  v-model="typedAnnualIncome"
                  :options="formatOptions.salary"
                  name="typedAnnualIncome"
                  type="text"
                  id="typedAnnualIncome"
                  class="form-control mini-input midi-input"
                  tabindex="0"
                  aria-labelledby="incomeSlider_label"
                ></cleave>
              </div>
              <LifetimeSliderInput
                v-model="annualIncome"
                :min="data.params.minSalary"
                :max="data.params.maxSalary"
                :step="data.params.salaryStep"
                :tooltips="false"
              />
            </div>
          </MDBCol>
        </MDBRow>
      </MDBCol>

      <MDBCol col="12" lg="6" class="pt-4 text-left">
        <MDBRow class="p-0">
          <MDBCol col="2" class="text-left pt-0">
            <div class="main-icon">
              <div class="icon-shield"></div>
            </div>
          </MDBCol>

          <MDBCol col="10" class="text-left pt-2">
            <p tabindex="0"><strong>
              {{ clientConfig.content.calculation.protectionCoverLabel }}
            </strong></p>

            <div 
              class="form-group pb-2" 
              v-if="!clientConfig.content.calculation.hideCoverAmount"
            >
              <label for="cover_amount" tabindex="0" id="cover_amount_label" class="pb-1">
                {{ clientConfig.content.calculation.coverAmountLabel }}
                <MDBTooltip 
                  v-model="tooltip2"
                  boundary="#ipApp"
                  direction="top"
                  offset="10"
                >
                  <template #reference>
                    <span class="icon-info"></span>
                  </template>
                  <template #tip>
                    <span>
                      {{ clientConfig.content.calculation.coverAmountTooltip }}
                    </span>
                  </template>
                </MDBTooltip>
              </label>
              <!-- <ValidationProvider name="coverProvider"> -->
                <input
                  type="hidden"
                  name="cover_amount"
                  id="cover_amount"
                  :value="coverAmount"
                />
              <!-- </ValidationProvider> -->
              <br />
              <MDBBtnGroup 
                class="multi-select-group shadow-0" 
                role="radiogroup" 
                aria-labelledby="cover_amount_label"
              >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="0.75"
                  @click="toggleCoverBtn"
                  :class="cover_75 ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  aria-label="75% of my income"
                  >75% of my income</MDBBtn
                >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="0.85"
                  @click="toggleCoverBtn"
                  :class="!cover_75 ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  aria-label="85% of my income*"
                  >85% of my income*</MDBBtn
                >
              </MDBBtnGroup>
              <br/>
              <small class="field-sub-text" v-if="!cover_75">
                {{ clientConfig.content.calculation.coverAmountWarning }}
              </small>
            </div>

            <div 
              class="form-group pb-2" 
              v-if="!clientConfig.content.calculation.hideBenefitPeriod"
            >
              <label for="benefit_period" tabindex="0" id="benefit_period_label" class="pb-1">
                {{ clientConfig.content.calculation.benefitPeriodLabel }}
              </label>
              <!-- <ValidationProvider name="benefitProvider"> -->
                <input
                  type="hidden"
                  name="benefit_period"
                  id="benefit_period"
                  :value="benefitPeriod"
                />
              <!-- </ValidationProvider> -->
              <br />
              <MDBBtnGroup 
                class="multi-select-group shadow-0" 
                role="radiogroup" 
                aria-labelledby="benefit_period_label"
              >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="2"
                  @click="toggleBenefitBtn"
                  :class="benefit_2 ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  aria-label="Up to 2 years"
                  >Up to 2 years</MDBBtn
                >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="65"
                  @click="toggleBenefitBtn"
                  :class="!benefit_2 ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  aria-label="Up to age 65"
                  >Up to age 65</MDBBtn
                >
              </MDBBtnGroup>
            </div>

            <div class="form-group">
              <label for="waiting_period" tabindex="0" id="waiting_period_label" class="pb-1">
                {{ clientConfig.content.calculation.waitingPeriodLabel }}
                <MDBTooltip 
                  v-if="clientConfig.content.calculation.showWaitingPeriodTooltip"
                  v-model="tooltip3"
                  boundary="#ipApp"
                  direction="top"
                  offset="10"
                >
                  <template #reference>
                    <span class="icon-info"></span>
                  </template>
                  <template #tip>
                    <span>
                      {{ clientConfig.content.calculation.waitingPeriodTooltip }}
                    </span>
                  </template>
                </MDBTooltip>
              </label>
              <!-- <ValidationProvider name="waitingProvider"> -->
                <input
                  type="hidden"
                  name="waiting_period"
                  id="waiting_period"
                  :value="waitingPeriod"
                />
              <!-- </ValidationProvider> -->
              <br />
              <MDBBtnGroup 
                class="multi-select-group shadow-0" 
                role="radiogroup"
                aria-labelledby="waiting_period_label"
              >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  :value="clientConfig.content.calculation.waitingPeriodLowerLimit"
                  @click="toggleWaitingBtn"
                  :class="waiting_LowerLimit ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  :aria-label="clientConfig.content.calculation.waitingPeriodLowerLimit + ' days'"
                  >{{ clientConfig.content.calculation.waitingPeriodLowerLimit }} days</MDBBtn
                >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  :value="clientConfig.content.calculation.waitingPeriodUpperLimit"
                  @click="toggleWaitingBtn"
                  :class="!waiting_LowerLimit ? 'active' : ''"
                  role="radio"
                  tabindex="0"
                  :aria-label="clientConfig.content.calculation.waitingPeriodUpperLimit + ' days'"
                  >{{ clientConfig.content.calculation.waitingPeriodUpperLimit }} days</MDBBtn
                >
              </MDBBtnGroup>
            </div>

          </MDBCol>
        </MDBRow>

      </MDBCol>
    </MDBRow>
    <!-- </ValidationObserver> -->

    <MDBRow 
      class="p-0" 
      v-if="!showCalculation"
    >
      <MDBCol 
        col="11"
        class="p-2 pt-4 pb-3 mx-auto text-center"
      >
        <MDBBtn
          color="primary"
          class="rounded"
          @click="calculateQuote"
          aria-label="Calculate button"
        >
          {{ clientConfig.content.calculation.calculateButtonLabel }}
        </MDBBtn>
      </MDBCol>
    </MDBRow>

    <MDBRow 
      class="p-0" 
      v-else
    >
      <MDBCol 
        col="12"
        md="8"
        class="p-3 pt-4 pb-md-4 text-center text-md-start"
      >
        <MDBBtn
          color="primary"
          class="rounded half"
          @click="printCalculation"
          aria-label="Print button"
        >
          {{ clientConfig.content.calculation.printButtonLabel }}
        </MDBBtn>

        <MDBBtn
          outline="primary"
          class="rounded d-sm-inline-block d-xs-inline-block d-lg-none ms-2"
          @click="calculateQuote"
          aria-label="Recalculate button"
        >
          {{ clientConfig.content.calculation.reCalculateButtonLabel }}
        </MDBBtn>
      </MDBCol>

      <MDBCol 
        col="12"
        md="4"
        class="p-3 pt-md-4 pb-3 pb-md-4 text-center text-md-end"
      >
        <MDBBtn
          color="primary"
          class="rounded"
          @click="clickToTab(3)"
          aria-label="Next button"
        >
          {{ clientConfig.content.calculation.nextButtonLabel }}
        </MDBBtn>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>